<template>
    <section>
        <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
            
            <v-text-field label="Selecciona una foto" @click="seleccionarFoto" v-model="nombreImagen" prepend-icon="mdi-file-image"></v-text-field>
            <input
            type="file"
            style="display: none"
            ref="image"
            accept="image/jpeg, image/jpg, image/png"
            @change="onImagenSeleccionada"
            >
        </v-flex>
    </section>
</template>
<script>
    export default{
        name: "SeleccionarFoto",

        data: () => ({
            urlImagen: '',
            archivoImagen: null,
            nombreImagen: '',
        }),
        
        methods: {
            seleccionarFoto() {
              this.$refs.image.click()
          },

          onImagenSeleccionada(e) {
              const files = e.target.files
              if(files[0] !== undefined) {
                this.nombreImagen = files[0].name
                if (this.nombreImagen.lastIndexOf('.') <= 0) {
                  return
              }
              const fr = new FileReader()
              fr.readAsDataURL(files[0])
              fr.addEventListener('load', () => {
                  this.urlImagen = fr.result
                  this.archivoImagen = files[0]
                  this.$emit("imagen", this.urlImagen)
              })
          } else {
            this.nombreImagen = ''
            this.archivoImagen = ''
            this.urlImagen = ''
        }
    },
    
},
}
</script>